<div class="agpr-includeExclude-container">
    <div *ngIf="headerLabel" class="agpr-includeExclude-headerLabelContainer">
        <agpr-button
            class="agpr-includeExclude-expandButton"
            [style]="buttonTypes.link"
            [icon]="expanded ? 'fa-solid fa-angle-down' : 'fa-solid fa-angle-right'"
            [disabled]="expanded && (value?.exclude?.length > 0 || value?.includeAll?.length > 0)"
            [expanded]="expanded"
            (click)="toggleExpanded()"
            [ariaLabel]="tooltip ?
                ((headerLabel | localize) + '. ' + ('Discover.targeting.searchFieldLabels.expandButton.tooltip' | localize) + '. ' + ('tooltipDetails' | localize))
                : ((headerLabel | localize) + '. ' + ('Discover.targeting.searchFieldLabels.expandButton.tooltip' | localize))"
        >
            <label
                [id]="id + '.label'"
                class="agpr-includeExclude-headerLabel"
            >
                {{ headerLabel | localize }}
            </label>
        </agpr-button>
        <span
            *ngIf="tooltip"
            role="img"
            class="agpr-includeExclude-infoIconStyle fa-regular fa-circle-info"
            [agprTooltip]="tooltip"
            tabindex="0"
        ></span>
    </div>
    <div class="agpr-includeExclude-chipsContainer" role="group" [attr.aria-labelledby]="id + '.label'">
        <div class="agpr-includeExclude-chipRow">
            <label
                [for]="id + '.subjectChips.autocomplete'"
                [@labelState]="expanded ? 'visible' : 'hidden'"
            >
                ({{'or' | localize}})
            </label>
            <agpr-subject-chips
                [id]="id + '.subjectChips'"
                class="agpr-contactEditor-inputable"
                [placeholder]="placeholder | localize"
                [ngModel]="value?.include"
                (ngModelChange)="handleChanges(includeOrExclude.include, $event)"
                (browseAll)="browseAll.emit({includeOrExclude: includeOrExclude.include})"
                (autocompleteBrowseAllClicked)="browseAll.emit({
                    includeOrExclude: includeOrExclude.include,
                    options: $event
                })"
            ></agpr-subject-chips>
        </div>
        <div
            [@containerState]="expanded ? 'visible' : 'hidden'"
            class="agpr-includeExclude-chipsContainer--expanded agpr-includeExclude-chipsContainer--expanded-subject"
            [style.display]="expanded ? 'grid' : 'none'"
        >
            <div class="agpr-includeExclude-chipRow">
                <label [for]="id + '.subjectChips.and.autocomplete'" class="agpr-includeExclude-chipRow-expandedLabel">
                    ({{'and' | localize}})
                </label>
                <agpr-subject-chips
                    [id]="id + '.subjectChips.and'"
                    class="agpr-contactEditor-inputable"
                    [placeholder]="placeholder | localize"
                    [ngModel]="value?.includeAll"
                    (ngModelChange)="handleChanges(includeOrExclude.includeAll, $event)"
                    (browseAll)="browseAll.emit({includeOrExclude: includeOrExclude.includeAll})"
                    (autocompleteBrowseAllClicked)="browseAll.emit({
                        includeOrExclude: includeOrExclude.includeAll,
                        options: $event
                    })"
                ></agpr-subject-chips>
            </div>
            <div class="agpr-includeExclude-chipRow">
                <label [for]="id + '.subjectChips.not.autocomplete'" class="agpr-includeExclude-chipRow-expandedLabel">
                    ({{'not' | localize}})
                </label>
                <agpr-subject-chips
                    [id]="id + '.subjectChips.not'"
                    class="agpr-contactEditor-inputable"
                    [placeholder]="placeholder | localize"
                    [ngModel]="value?.exclude"
                    (ngModelChange)="handleChanges(includeOrExclude.exclude, $event)"
                    (browseAll)="browseAll.emit({includeOrExclude: includeOrExclude.exclude})"
                    (autocompleteBrowseAllClicked)="browseAll.emit({
                        includeOrExclude: includeOrExclude.exclude,
                        options: $event
                    })"
                ></agpr-subject-chips>
            </div>
        </div>
    </div>
</div>
